import { render, staticRenderFns } from "./QueryLogDetail.vue?vue&type=template&id=436e556c&"
import script from "./QueryLogDetail.vue?vue&type=script&lang=js&"
export * from "./QueryLogDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports